import { render } from "./OpenAIChat.vue?vue&type=template&id=cae5a3b8&scoped=true"
import script from "./OpenAIChat.vue?vue&type=script&lang=js"
export * from "./OpenAIChat.vue?vue&type=script&lang=js"

import "./OpenAIChat.vue?vue&type=style&index=0&id=cae5a3b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cae5a3b8"]])

export default __exports__